import React from 'react'
import styles from './CreateAccountStep.scss'
import {S2DLayout} from '../S2DLayout'
import {CTA} from 'common/styleguide/CTA'
import {SigninButton} from 'common/SigninButton'
import {buildQueryString} from 'lib/utils'
import querystring from 'querystring'

export class CreateAccountStep extends React.Component {
  render () {
    const {selectedDevice, onPrev} = this.props
    const {hot} = querystring.parse(window.location.search.substring(1))
    const postSignin = true
    const query = hot
      ? buildQueryString({hot, postSignin, selectedDevice})
      : buildQueryString({postSignin, selectedDevice})
    const redirect = `${window.location.pathname}?${query}`
    const signupURL = `/signup?redirect=${encodeURIComponent(redirect)}`
    return (
      <S2DLayout
        title='Create Account'
        step={2}
        onClickPrev={onPrev}
        onClickNext={() => {}}
        disableNext={'Please create an account to continue'}>
        <div className={styles.CreateAccountStep}>
          <p>
            To send the route to your iOS device, you will need to create a free
            account with Ride with GPS.
          </p>
          <CTA href={signupURL}>Create Account</CTA>
          <p>
            Already have an account?
          </p>
          <SigninButton redirectTo={redirect} />
        </div>
      </S2DLayout>
    )
  }
}
